export function findNew(createdDate: Date, moment: any, comparisonDate = new Date()) {
  const created = moment(createdDate).format("YYYY-MM-DD");
  const dateToCompare = moment(comparisonDate);
  return dateToCompare.diff(created, "days") <= 7;
}
